import {
  ChevronPaginationDoubleLeftIcon,
  ChevronPaginationLeftIcon,
  ChevronPaginationRightIcon,
} from "src/assets/icons";
import {
  Container,
  SummaryContainer,
  ControlsContainer,
  NavButton,
} from "./PaginationControls.styles";
import PageSizeDropdown from "./PageSizeDropdown";

interface PaginationControlsProps {
  offset?: number;
  setOffset: (offset: number) => void;
  pageSize?: number;
  setPageSize: (pageSize: number) => void;
  totalCount?: number;
}

export default ({
  offset = 0,
  setOffset,
  pageSize = 10,
  setPageSize,
  totalCount = 0,
}: PaginationControlsProps) => {
  const currentPageRangeText =
    offset + 1 + " - " + Math.min(offset + pageSize, totalCount);
  return (
    <Container>
      <SummaryContainer>
        {currentPageRangeText} of {totalCount}
      </SummaryContainer>
      <ControlsContainer>
        Rows per page
        <PageSizeDropdown pageSize={pageSize} setPageSize={setPageSize} />
        <NavButton onClick={() => setOffset(0)} disabled={offset === 0}>
          <ChevronPaginationDoubleLeftIcon />
        </NavButton>
        <NavButton
          onClick={() => setOffset(Math.max(offset - pageSize, 0))}
          disabled={offset === 0}
        >
          <ChevronPaginationLeftIcon />
        </NavButton>
        <NavButton
          onClick={() => setOffset(offset + pageSize)}
          disabled={offset + pageSize >= totalCount}
        >
          <ChevronPaginationRightIcon />
        </NavButton>
      </ControlsContainer>
    </Container>
  );
};
